import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Ressult() {
  return (
    <section className="result_pick p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#FF6C7F" }}>Results</span>
            </h2>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <p>
              With the help of our amazing team, we have created a simple,
              user-centric app that can be helpful to anyone and everyone. From
              sending holiday wishes to family and wishing birthday to a friend
              to sending a business update to a colleague, iRemembered is the
              new, must have app in your smartphone.
            </p>
            <div className="result_main_num">
              <div className="result_num_box">
                <h2 style={{ color: "#FF6C7F" }}>96%</h2>
                <p>CUSTOMER SATISFACTION</p>
              </div>
              <div className="result_num_box">
                <h2 style={{ color: "#FF6C7F" }}>20+</h2>
                <p>5 STAR REVIEWS</p>
              </div>
              <div className="result_num_box">
                <h2 style={{ color: "#FF6C7F" }}>30+</h2>
                <p>RECOMMENDATIONS</p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Ressult;
